import {Component} from '@angular/core';
import {SettingsManagerService} from "./services/settings-manager.service";
import {environment} from "@environments/environment";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    public settingsManagerService: SettingsManagerService
  ) {

    // Language setup
    settingsManagerService.initLanguages();

    // Update favicon
    const favIcon: HTMLLinkElement = document.querySelector('head link[rel="icon"]');
    favIcon.href = environment.faviconUrl;

    // Update title
    document.title = environment.title;

  }

}
